import type { FaireProductEntity } from "../../entity_types/product";

export const p_78zwxrnbj9: FaireProductEntity = {
  token: "p_78zwxrnbj9",
  type: "product",
  name: "Red Ribbon Candy Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3dbb2aa65a26af57a4ceb555649e3f3801600cc2898dcf98bdc6470767c7f252.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc9805bb61c5de4636c96ca817c8b13838a60595c5562ce26da6a25b860361ad.jpeg",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:59.122Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
